import { APIService } from "../../../../../../network/api/APIService";


export const WithdrawalData = (formData) => {
    let endpoint = "/affiliate/payout/withdrawals/admin/item/";


    const config = {
        endpoint: endpoint,
        method: "PUT",
        credentials: "include",
        data: formData,
    };

    return APIService(config);
};